import { Box, Button, Collapse, Typography } from "@mui/material";
import { useQuery } from "react-query";
import StatsCard from "src/components/common/StatsCard";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {
  getLandDashboardDetails,
  getTableDashboardDetails,
} from "src/utils/api/dashboard";
import defaultStyles, { StylesClasses } from "../styles";
import { getStyles } from "src/styles/theme";
import StatusBarChart from "src/components/common/StatusBarChart";
import { exportDprTableToXlsx, formatDataForBarChart } from "src/utils/helper";
import {
  DprDashboardTable,
  DprDashboardTableProps,
} from "src/components/common/DashboardTable/dprDashboard";
import { useState } from "react";
import { AxiosResponse } from "axios";
import DashboardTableSkeleton from "src/components/common/DashboardTableSkeleton";

const TOP_HEADERS = [
  "",
  "DPR Pending",
  "DPR under DNO",
  "Query from DNO",
  "DPR under SNO",
  "Query from SNO",
  "DPR under Admin",
  "Query from Admin",
  "DPR Approved",
  "DPR Rejected",
];

const SUB_HEADERS = [
  "S.No",
  "State",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
  "No",
  "Area (ha)",
];

const DprDashboard = () => {
  const [tableRows, setTableRows] = useState<any[]>([]);
  const [tableState, setTableState] = useState(false);
  const [isTabLoading, setIsTabLoading] = useState(true);

  const queryParams = { type: "dpr" };

  const { data: dashboard, isLoading: dashboardLoading } = useQuery(
    ["dprLandDashboard"],
    () => getLandDashboardDetails(queryParams),
    {
      onSuccess: () => {},
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const { isLoading } = useQuery(
    ["table-dpr"],
    () => getTableDashboardDetails(queryParams),
    {
      onSuccess: (res: AxiosResponse) => {
        setTableRows(
          res?.data?.stats.map((item: any, idx: number) => ({
            id: idx,
            sno: idx + 1,
            state: item.state,
            totalNumberAllDpr: item.totalNumberAllDpr,
            totalAreaAllDpr: item.totalAreaAllDpr,
            totalNumberDprUnderDno: item.totalNumberDprUnderDno,
            totalAreaDprUnderDno: item.totalAreaDprUnderDno,
            totalNumberQueryFromDno: item.totalNumberQueryFromDno,
            totalAreaQueryFromDno: item.totalAreaQueryFromDno,
            totalNumberDprUnderSno: item.totalNumberDprUnderSno,
            totalAreaDprUnderSno: item.totalAreaDprUnderSno,
            totalNumberQueryFromSno: item.totalNumberQueryFromSno,
            totalAreaQueryFromSno: item.totalAreaQueryFromSno,
            totalNumberDprUnderAdmin: item.totalNumberDprUnderAdmin,
            totalAreaDprUnderAdmin: item.totalAreaDprUnderAdmin,
            totalNumberQueryFromAdmin: item.totalNumberQueryFromAdmin,
            totalAreaQueryFromAdmin: item.totalAreaQueryFromAdmin,
            totalNumberDprApproved: item.totalNumberDprApproved,
            totalAreaDprApproved: item.totalAreaDprApproved,
            totalNumberDprRejected: item.totalNumberDprRejected,
            totalAreaDprRejected: item.totalAreaDprRejected,
          }))
        );
        setIsTabLoading(false);
      },
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const dashboardTableData: DprDashboardTableProps = {
    topHeader: TOP_HEADERS,
    header: SUB_HEADERS,
    data: tableRows,
  };

  const styles = getStyles<StylesClasses>(defaultStyles);

  const formattedData = formatDataForBarChart(dashboard?.data?.stats);

  return (
    <>
      {dashboardLoading || isLoading || isTabLoading ? (
        <DashboardTableSkeleton />
      ) : (
        <>
          <Box {...styles("topHeader")}>
            <Box
              sx={{ width: "100%", marginBottom: "20px", alignSelf: "center" }}
            >
              <StatusBarChart
                data={formattedData}
                label={"Status of DPR under GCP"}
              />
            </Box>
            <Box {...styles("statsCardWrapper")}>
              {dashboard?.data?.stats.map((stat: any, index: number) => (
                <StatsCard
                  key={index}
                  title={`${stat.description.toUpperCase()}`}
                  value={`${stat?.number}`}
                  area={stat?.totalArea}
                  customStyles={{ valueCard: styles("statsCard").sx }}
                />
              ))}
            </Box>
          </Box>
          <Box {...styles("dashboardTableWrapper")}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h5">Status of DPR Under GCP</Typography>
              <Button
                variant="outlined"
                onClick={() => setTableState(!tableState)}
              >
                {tableState ? (
                  <>
                    Compress
                    <ArrowUpwardIcon sx={{ marginLeft: "10px" }} />
                  </>
                ) : (
                  <>
                    Expand
                    <ArrowDownwardIcon sx={{ marginLeft: "10px" }} />
                  </>
                )}
              </Button>
            </Box>
            <Collapse in={tableState}>
              <Button
                variant="outlined"
                onClick={() =>
                  exportDprTableToXlsx(
                    dashboardTableData.data,
                    dashboardTableData.header,
                    dashboardTableData.topHeader
                  )
                }
                sx={{ float: "right", marginBottom: "20px" }}
              >
                Export
              </Button>
              <DprDashboardTable {...dashboardTableData} />
            </Collapse>
          </Box>
        </>
      )}
    </>
  );
};

export default DprDashboard;
